// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"4ba9a086","152":"88d295ce","223":"da8644c5","276":"8081cda1","296":"9e08e18c"}[chunkId] + ".chunk.js";
};